import { API, Endpoints } from '@brg/api';
import { useEffect, useState } from "react";
import useLocalization from "../useLocalization";
export var useGetComments = function (postId, t, isLMS) {
    var _a = useState(undefined), resp = _a[0], setResp = _a[1];
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(false), error = _c[0], setError = _c[1];
    var language = useLocalization().language;
    useEffect(function () {
        if (!postId)
            return;
        setIsLoading(true);
        var request = API.request()
            .endpoint(Endpoints.gateway)
            .url('message/api/comment/GetByEntity')
            .get()
            .addQuery('entityId', postId || '')
            .addQuery('entityType', 'post');
        if (isLMS) {
            request.addQuery('statuses', 0);
        }
        request.send()
            .then(function (r) { return r ? r.json() : undefined; })
            .then(function (r) {
            setIsLoading(false);
            setResp(r || []);
        })
            .catch(function (e) {
            setIsLoading(false);
            setError(true);
        });
    }, [postId, t, isLMS]);
    return [API.toLang(resp, language), isLoading, error];
};
//# sourceMappingURL=useGetComments.js.mapimport { API, Endpoints } from '@brg/api';
import { useEffect, useState } from "react";
import useLocalization from "../useLocalization";
export var useGetComments = function (postId, t, isLMS) {
    var _a = useState(undefined), resp = _a[0], setResp = _a[1];
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(false), error = _c[0], setError = _c[1];
    var language = useLocalization().language;
    useEffect(function () {
        if (!postId)
            return;
        setIsLoading(true);
        var request = API.request()
            .endpoint(Endpoints.gateway)
            .url('message/api/comment/GetByEntity')
            .get()
            .addQuery('entityId', postId || '')
            .addQuery('entityType', 'post');
        if (isLMS) {
            request.addQuery('statuses', 0);
        }
        request.send()
            .then(function (r) { return r ? r.json() : undefined; })
            .then(function (r) {
            setIsLoading(false);
            setResp(r || []);
        })
            .catch(function (e) {
            setIsLoading(false);
            setError(true);
        });
    }, [postId, t, isLMS]);
    return [API.toLang(resp, language), isLoading, error];
};
//# sourceMappingURL=useGetComments.js.map